

































import { Component, Prop, Vue, Emit } from "vue-property-decorator";
import { Col, Row, Tag, Image, Icon } from 'vant';
import { DiscussTopicInfo } from  "@/data/local/discuss";

Vue.use(Col);
Vue.use(Row);
Vue.use(Tag);
Vue.use(Image);
Vue.use(Icon);

@Component({})
export default class DiscussTopicItem extends Vue {
  @Prop(Object)
  private itemData: DiscussTopicInfo | null;

  visitorAvator: string = "http://res.bchun.com/wp-content/uploads/2020/03/visitor-avator.png";
  adminAvator: string = "http://res.bchun.com/wp-content/uploads/2020/03/admin-avator.png";

  created() {
    
  }

  mounted() {
    
  }

  get cat(): string {
    if (this.itemData.cat === 1) {
      return "贷款业务";
    } else if (this.itemData.cat === 2) {
      return "提取业务";
    } else if (this.itemData.cat === 3) {
      return "缴存业务";
    } else {
      return "其他业务"
    }
  }

  get avator(): string {
    if (!this.itemData.avatorUrl || this.itemData.avatorUrl === "") {
      return this.visitorAvator;
    }

    return this.itemData.avatorUrl;
  }

  private onClickItem() {
    this.$router.push({path: "/fund/forum/answer/" + this.itemData.id});
  }
}
